export const iconFontAwesomeHumanitarianBuilding = (
	<i className="fa-solid fa-building"></i>
);
